export default __webpack_public_path__ + "static/media/p.db7dbd48.wav";